"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = exports.ChipTypes = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const PresentationContext_1 = require("./PresentationContext");
const Tooltip_1 = require("./Tooltip");
const Css_1 = require("../Css");
const useTestIds_1 = require("../utils/useTestIds");
// exporting for using in type prop as constant - this could be moved and become a global list for colors
exports.ChipTypes = {
    caution: "caution",
    warning: "warning",
    success: "success",
    light: "light",
    dark: "dark",
    neutral: "neutral",
    darkMode: "darkMode",
    info: "info",
};
/** Kinda like a chip, but read-only, so no `onClick` or `hover`. */
function Chip({ type = exports.ChipTypes.neutral, ...props }) {
    const { fieldProps } = (0, PresentationContext_1.usePresentationContext)();
    const { text, title, xss = {}, compact = fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.compact } = props;
    const tid = (0, useTestIds_1.useTestIds)(props, "chip");
    return (0, Tooltip_1.maybeTooltip)({
        title,
        placement: "bottom",
        children: ((0, jsx_runtime_1.jsx)("span", { css: {
                ...Css_1.Css[compact ? "xs" : "sm"].dif.aic.br16.pl1.px1.pyPx(2).gray900.$,
                ...typeStyles[type],
                ...xss,
            }, ...tid, children: (0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.lineClamp1.breakAll.$, children: text }) })),
    });
}
exports.Chip = Chip;
const typeStyles = {
    caution: Css_1.Css.bgYellow200.$,
    warning: Css_1.Css.bgRed200.$,
    success: Css_1.Css.bgGreen200.$,
    light: Css_1.Css.bgWhite.$,
    dark: Css_1.Css.bgGray900.white.$,
    neutral: Css_1.Css.bgGray200.$,
    darkMode: Css_1.Css.bgGray700.white.$,
    info: Css_1.Css.bgBlue100.$,
};
